export default __webpack_public_path__ + "static/media/GPA_Banner_Find_Job_Openings.8ed0ba61.jpg";